module.exports = __webpack_public_path__ + "static/media/hab5-0.284e6a58.jpg";